module.exports = __webpack_public_path__ + "9779d9a1/img/arrow-left-icon.785c715c.svg";